<template>
  <div>
    <!-- MODAL NAVIGATION USER-->
    <b-button
      v-permission="'form_protocol_query.history'"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.modal-protocol-query-history
      class="waves-effect"
      variant="outline-warning"
      @click="getListHistory">
        {{$t('protocol_query.history')}}
    </b-button>
    <b-modal
      id="modal-protocol-query-history"
      cancel-variant="outline-secondary"
      hide-footer="true"
      scrollable
      size="xl"
      :title="$t('protocol_query.history')">
      <b-table
              hover
              caption-top
              responsive="sm"
              table-variant="warning"
              :items="listItems"
              :fields="fieldsTable">
              <template #cell(created_at)="{item: {created_at}}">
                <span>{{ formatDate(created_at) }}</span>
              </template>
      </b-table>
    </b-modal>
  </div>
</template>

<script>

import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BTable,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  VBTooltip
} from 'bootstrap-vue'

import FormProtocolQueryService from '@/services/api/FormProtocolQueryService'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BContainer,
    BCard,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BRow,
    BCol,
    BForm,
    BButton,
    BTable
  },
  props: {
    type: {
      type: String,
      default: null
    },
    protocol_number: {
      type: String,
      default: null
    }
  },
  data: () => ({
    showModal: false,
    service: null,
    listItems: [],
    fieldsTable:[
      { key: 'created_at', label: 'Data/hora', sortable: true,},
      { key: 'navigationUser.ip', label: 'IP', sortable: true,},
      { key: 'navigationUser.port', label: 'Porta' },
      { key: 'navigationUser.osName', label: 'OS Name' },
      { key: 'navigationUser.osVersion', label: 'OS Version' },
      { key: 'navigationUser.browserName', label: 'Browser Name' },
      { key: 'navigationUser.browserVersion', label: 'Browser Version' },
    ],
  }),
  computed: {

  },
  methods: {
    getListHistory(){
      this.$vs.loading()
      const params = {
        protocol_number: this.protocol_number
      }
      this.service.getHistory(this.type, params).then(
        data => {
          this.$vs.loading.close()
          this.listItems = data
        },
        error => {
          this.$vs.loading.close()
        })
    },
    formatDate(timestamp) {
      const format = 'ddd, DD/MM/YYYY HH:mm'
      return this.$utils.format.dateWithFormat(timestamp, format)
    },
  },
  beforeMount() {
     //Services
     this.service = FormProtocolQueryService.build(this.$vs)
  }
}
</script>
<style scoped>

</style>
